import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'SearchIcon',
  viewBox: '0 0 16 16',
  d: 'M11.287 10.085a5.118 5.118 0 0 0-7.788-6.586 5.117 5.117 0 0 0 6.585 7.788l.048.051 2.412 2.412a.853.853 0 1 0 1.206-1.206l-2.412-2.412a.882.882 0 0 0-.051-.047Zm-1.758-5.38a3.411 3.411 0 1 1-4.824 4.824A3.411 3.411 0 0 1 9.53 4.705Z',
});
